module.exports = __webpack_public_path__ + "assets/80c057e1507ccf19c442b46041aaaa39.png";